<template>
  <div class="important-page-c display--flex fd--column">
    <!-- 搜索 -->
    <div
      class="search-form btn-2b5a95"
    >
<div class="l-w" :style="{
        height: $store.state.global.isSearchExtend_1
          ? ''
          : $store.state.global.searchFormHeight_1 + 10 + 'px',
      }">
      <el-form
        label-position="right"
        :class="$store.state.global.isSearchExtend_1 ? '' : 'overflow--hidden'"
				:model="searchForm"
				@submit.native.prevent
      >
        <el-form-item label="流水号:">
          <el-input 
						v-model.trim="searchForm.id" 
						@keyup.enter.native="seach"
						clearable />
        </el-form-item>
        <el-form-item label="类型编号:">
          <el-input 
						v-model.trim="searchForm.typecode" 
						@keyup.enter.native="seach"
						clearable />
        </el-form-item>
        <el-form-item label="类型名称:">
          <el-input 
						v-model.trim="searchForm.typename" 
						@keyup.enter.native="seach"
						clearable />
        </el-form-item>
        <el-form-item label="	值:">
          <el-input 
						v-model.trim="searchForm.val" 
						@keyup.enter.native="seach"
						clearable />
        </el-form-item>
        <el-form-item label="是否可用">
          <el-select 
						v-model="searchForm.enableflag" 
						@keyup.enter.native="seach"
						@visible-change="visibleType"
						ref="selectref"
						clearable>
            <el-option value="1" label="是"></el-option>
            <el-option value="0" label="否"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
      <div class="r-w">

      <el-button
        type="primary"
        icon="el-icon-search"
        @click="seach"
        :loading="!$store.state.global.isEndRequest"
        class="btn-2b5a95"
        >搜索</el-button
      >
			<el-button type="primary" @click="resetQuery">重置</el-button>
      <el-button
        type="primary"
        :icon="
          $store.state.global.isSearchExtend_1
            ? 'el-icon-arrow-up'
            : 'el-icon-arrow-down'
        "
        v-if="$store.state.global.searchExtend_1"
        class="btn-2b5a95"
        @click="onExtendClick('isSearchExtend_1')"
        >{{ $store.state.global.searchExtendText_1 }}</el-button
      >
    </div>

    </div>

    <!-- 按钮操作 -->
    <div
      class="Btn-w eaf4ff-btn"
      v-if="tableRes.buttonlist && tableRes.buttonlist.length"
      :style="{
        height: $store.state.global.isBtnExtend_1
          ? ''
          : $store.state.global.BtnHeight_1 + 10 + 'px',
      }"
    >
      <div
        class="btn-l"
        v-if="tableRes.buttonlist"
        :class="$store.state.global.isBtnExtend_1 ? '' : 'overflow--hidden'"
      >
        <el-button
          v-for="(item, index) in tableRes.buttonlist"
          :key="index"
          type="primary"
          @click="onClickBtn(item.buttonname)"
          >{{ item.name }}
        </el-button>
      </div>
      <div class="Btn-extend">
        <el-button
          type="primary"
          v-if="$store.state.global.btnExtend_1"
          class="btn-2b5a95"
          :icon="
            $store.state.global.isBtnExtend_1
              ? 'el-icon-arrow-up'
              : 'el-icon-arrow-down'
          "
          @click="onExtendClick('isBtnExtend_1')"
          >{{ $store.state.global.BtnExtendText_1 }}</el-button
        >
      </div>
    </div>

    <!-- 表格 -->
    <el-table
      :data="tableRes.list"
			stripe
			border
			:header-cell-style="{ background: '#044d8c', color: '#fff'}"
      ref="multipleTable"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" />
      <el-table-column label="流水号" prop="id" align="center" />
      <el-table-column label="类型编号" prop="typecode" align="center" />
      <el-table-column label="类型名称" prop="typename" align="center" />
      <el-table-column label="键" prop="key" align="center" />
      <el-table-column label="值" prop="val" align="center" />
      <el-table-column label="排序权重" prop="rank" align="center">
        <template slot-scope="scope">
          <div class="input-box">
            <el-input size="small" v-model.trim="scope.row.rank" clearable></el-input>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="是否可用" prop="enableflag" align="center">
        <template slot-scope="scope">
          {{ available[scope.row.enableflag] }}
        </template>
      </el-table-column>
      <el-table-column label="备注" prop="remark" align="center" />
    </el-table>

    <!-- 分页 -->
    <el-pagination
      background
      @current-change="handleCurrentChange"
      :current-page="pageinfo.pageindex"
      :page-size="pageinfo.pagesize"
      :page-sizes="[10, 20, 30, 40, 50]"
      layout="total, prev, pager, next, jumper"
      :total="tableRes.totalcount"
    ></el-pagination>

    <!--添加，修改-->
    <el-dialog
      class="btn-2b5a95"
			v-dialogDrag
      width="30%"
			:title="dialogTitle"
			:close-on-click-modal='false'
      :visible.sync="showAddModal"
      v-if="showAddModal"
      append-to-body
    >
      <el-form
        :model="dynamicValidateForm"
        ref="dynamicValidateForm"
        label-width="20%"
        class="demo-dynamic form-item-w-100"
        status-icon
        :rules="rules"
      >
        <el-form-item prop="typeuername" label="类型编号">
          <el-select 
						v-model="dynamicValidateForm.typeuername"
						@change="handelChange"
						>
            <el-option
              v-for="item in dictypes"
              :key="item.key"
              :value="item.key"
              :label="item.val + '(' + item.code + ')'"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="key" label="键">
          <el-input v-model.trim="dynamicValidateForm.key" clearable/>
        </el-form-item>

        <el-form-item prop="val" label="值">
          <el-input v-model.trim="dynamicValidateForm.val" clearable/>
        </el-form-item>

        <el-form-item prop="rank" label="排序权重">
          <el-input v-model.trim="dynamicValidateForm.rank" clearable/>
        </el-form-item>

        <el-form-item prop="enableflag" label="是否可用" class="nickName">
          <el-select v-model="dynamicValidateForm.enableflag">
            <el-option value="1" label="是"></el-option>
            <el-option value="0" label="否"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="备注">
          <el-input v-model.trim="dynamicValidateForm.remark" clearable/>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="submitAddOrEditForm('dynamicValidateForm')"
          :loading="!$store.state.global.isEndRequest"
          >提交
        </el-button>
      </span>
    </el-dialog>

    <Export
      :exportTitle="'字典键值管理'"
      :transferDialog="transferDialog"
      :exportUrl="exportUrl"
      :exportexcelUrl="exportexcelUrl"
      :exportsaveUrl="exportsaveUrl"
      :searchForm="searchForm"
      @onCloseExport="onCloseExport"
    ></Export>
  </div>
</template>

<script>
import { part } from "@/utils/mixins";
import { mapActions } from "vuex";
import Export from "@/components/Export/index.vue";
import {
  dic_list,
  dic_input,
  dic_save,
  dic_delete,
  dic_enable,
  dic_export,
  dic_exportexcel,
  dic_exportsave,
  dictype_combox,
  dic_datasave,
} from "@/request/api/allChildrenProject";
import { _moneyintype_dialogresult } from "@/request/api/public";
import { myRequest } from "@/request/index";
import {
  selectCheck,
  confirmCallBack,
  messageTip,
  createObjParams,
  formatDare,
} from "@/utils/util";
import { _available } from "@/assets/js/filedValueFlag";

export default {
  mixins: [part],
  name: "dic",
  components: { Export },
  props: {
    exportUrl: {
      default: () => dic_export,
    },
    exportexcelUrl: {
      default: () => dic_exportexcel,
    },
    exportsaveUrl: {
      default: () => dic_exportsave,
    },
  },
  data() {
    //数值表单规则
    var checkfield = (rule, value, callback) => {
      if (!(value + "")) {
        return callback(new Error("必填字段"));
      } else {
        if (isNaN(Number(value))) {
          callback(new Error("请输入数字值"));
        } else {
          callback();
        }
      }
    };
    return {
      transferDialog: false, //导出框

      itemId: null, //首表格项id
      searchForm: {},
      tableRes: {}, //列表接口
      pageinfo: {
        pageindex: 1,
        pagesize: 10,
      }, //页数查询
      showAddModal: false, //显示表单框
      multipleSelection: [], //选中的表格项
      dynamicValidateForm: {}, //表单
      rules: {
        typename: [{ trigger: "blur", message: "必填字段", required: true }],
        key: [{ trigger: "blur", message: "必填字段", required: true }],
        val: [{ trigger: "blur", message: "必填字段", required: true }],
        rank: [{ trigger: "blur", message: "必填字段", required: true }],
        enableflag: [{ trigger: "blur", message: "必填字段", required: true }],
      }, //表单规则
      dialogTitle: "", //对话框标题

      selectTable: {},
      selectTableUrl: "",
      showLevel2Modal: false, //二级项目

      dictypes: [],
      available: _available,
    };
  },
  created() {
    this.getDataList();
    this.dictypeCombox();
		window.addEventListener("keyup", this.enterSelect);
  },
  methods: {
    ...mapActions("global", ["onExtendClick"]),
		enterSelect(e) {
			if(e.keyCode == 13) {
				this.getDataList();
			}
		},
		visibleType(e) {
			if(!e) {
				this.$refs.selectref.blur();
			}
		},
    //关闭导出框
    onCloseExport(bool) {
      this.transferDialog = false;
    },
    //导出 click
    btnExport() {
      this.transferDialog = true;
    },
		reset() {
			this.searchForm = {
				id: null,
				typecode: null,
				typename: null,
				val: null,
				enableflag: null
			}
		},
		resetQuery() {
			this.reset();
			this.getDataList();
		},
    //搜索 click
    seach() {
      this.pageinfo.pageindex = 1;
      this.getDataList();
    },
    //列表查询 api
    getDataList() {
      myRequest({
        url: dic_list,
        data: Object.assign(this.searchForm, this.pageinfo),
      }).then((res) => {
        if (res.data.code === "200") {
          this.tableRes = res.data.data;
        }
      });
    },
    //切换当前页
    handleCurrentChange(val) {
      this.pageinfo.pageindex = val;
      this.getDataList();
    },
		handelChange(e) {
			let obj = {};
			  obj = this.dictypes.find((item)=>{ 
			    return item.key === e; 
			  });
			this.dynamicValidateForm.typename = obj.val + '(' + obj.code + ')';
			this.dynamicValidateForm.typeid = obj.key;
		},
    //触发所有btn方法
    onClickBtn(methodsName) {
      this.$options.methods[methodsName].call(this); //btnAdd ... （防止修改this指向）
    },
    //添加click
    btnAdd() {
      this.dialogTitle = "添加";
      this.dynamicValidateForm = {
        rank: 0,
        enableflag: "1",
      };
      this.showAddModal = true;
    },
    //修改click
    btnEdit() {
      this.dialogTitle = "修改";
      selectCheck(this.multipleSelection, "修改", false, () => {
        this.editRoutePage(this.multipleSelection[0].id);
      });
    },
    //删除click
    btnDel() {
      selectCheck(this.multipleSelection, "删除", true, () => {
        confirmCallBack({
          title: "提示",
          content: "此操作将永久删除选中的数据！",
          success: () => {
            this.delTableItem(this.multipleSelection.map((i) => i.id));
          },
          fail: () => {
            messageTip({
              message: "取消操作",
              type: "info",
            });
          },
        });
      });
    },
    //启用 click
    btnEnable() {
      selectCheck(this.multipleSelection, "启用", true, () => {
        confirmCallBack({
          title: "提示",
          content: "该数据是否启用！",
          success: () => {
            this.isenabled(
              this.multipleSelection.map((i) => i.id),
              1
            );
          },
          fail: () => {
            messageTip({
              message: "取消操作",
              type: "info",
            });
          },
        });
      });
    },
    //禁用 click
    btnDisable() {
      selectCheck(this.multipleSelection, "禁用", true, () => {
        confirmCallBack({
          title: "提示",
          content: "该数据是否禁用！",
          success: () => {
            this.isenabled(
              this.multipleSelection.map((i) => i.id),
              0
            );
          },
          fail: () => {
            messageTip({
              message: "取消操作",
              type: "info",
            });
          },
        });
      });
    },
    //刷新 click
   btnRefresh() {
      this.getDataList();
    },
    //修改路由页 api
    editRoutePage(id) {
      myRequest({
        url: dic_input,
        data: {
          id: id,
        },
      }).then((res) => {
        if (res.data.code === "200") {
          this.showAddModal = true;
          this.dynamicValidateForm = res.data.data.tdic;
					this.dynamicValidateForm.typeuername = res.data.data.typeuername;
          delete this.dynamicValidateForm.inserttime; //inserttime 该字段不用传
          delete this.dynamicValidateForm.deleteflag; //deleteflag 该字段不用传
        }
      });
    },
    //提交-（添加，修改） api
    submitAddOrEditForm(dynamicValidateForm) {
      this.$refs[dynamicValidateForm].validate((valid) => {
        if (valid) {
          myRequest(
            {
              url: dic_save,
              data: this.dynamicValidateForm,
            },
            {
              isRefTableList: true,
              that: this,

              modal: "showAddModal",
            }
          );
        }
      });
    },
    //删除 api
    delTableItem(idArr) {
      myRequest(
        {
          method: "post",
          url: dic_delete,
          data: this.$qs.stringify(
            {
              ids: idArr,
            },
            {
              arrayFormat: "repeat",
            }
          ),
        },
        {
          isRefTableList: true,
          that: this,
        }
      );
    },
    //启用，禁用 api
    isenabled(ids, isenabled) {
      myRequest(
        {
          method: "post",
          url: dic_enable,
          data: this.$qs.stringify(
            {
              ids: ids,
              enable: isenabled,
            },
            {
              arrayFormat: "repeat",
            }
          ),
        },
        {
          isRefTableList: true,
          that: this,
        }
      );
    },
    //字典类型编号列表 api
    dictypeCombox() {
      myRequest({
        url: dictype_combox,
      }).then((res) => {
        if (res.data.code === "200") {
          this.dictypes = res.data.data.options;
        }
      });
    },
    //保存表格 api
    btnSave() {
      myRequest(
        {
          method: "post",
          url: dic_datasave,
          data: this.$qs.stringify(
            {
              ids: this.tableRes.list.map((i) => i.id),
              mds: this.tableRes.list.map((i) => i.rank),
            },
            {
              arrayFormat: "repeat",
            }
          ),
        },
        {
          isRefTableList: true,
          that: this,
        }
      );
    },
    //选中表格数据改变时
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  },
};
</script>


<style  lang="scss">
</style>